export default async () => {
  // Set global environment variables
  process.env.LANG = 'en_US.UTF-8';
  process.env.TZ = 'GMT';

  // Suppress console logs in CI/CD environment
  const isCI = !!process.env.IS_CI || !!process.env.CI;

  if (!isCI) {
    // Perform any asynchronous setup here
    // For example, setting up a test database, etc.
    console.log('[jest.global-setup.ts] Global setup complete');
  }
};
